import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  makeStyles,
  Grid,
  Link,
  IconButton,
  Container,
} from "@material-ui/core";
import FacebookIcon from "@material-ui/icons/Facebook";
import TwitterIcon from "@material-ui/icons/Twitter";
import InstagramIcon from "@material-ui/icons/Instagram";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import PhoneIcon from "@material-ui/icons/Phone";
import LocationOnIcon from "@material-ui/icons/LocationOn";

const useStyles = makeStyles((theme) => ({
  footer: {
    background: theme.palette.type === "dark" ? "#000" : "#f5f5f5",
    color: "#333",
    padding: theme.spacing(4),
    marginTop: theme.spacing(1),
  },
  sectionTitle: {
    fontWeight: "bold",
    marginBottom: theme.spacing(2),
    color: theme.palette.type === "dark" ? "#fff" : "#000",
  },
  link: {
    color: "#8601af",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  socialMediaIcon: {
    color: "#8601af",
    marginRight: theme.spacing(1),
    "&:hover": {
      color: "#8601af",
    },
  },
  copyright: {
    textAlign: "center",
    padding: theme.spacing(2),
    color: theme.palette.type === "dark" ? "#fff" : "#000",
  },
  logo: {
    width: "180px",
    height: "auto",
    marginBottom: theme.spacing(2),
  },
  contactItem: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
    color: theme.palette.type === "dark" ? "#fff" : "#000",
  },
  contactIcon: {
    marginRight: theme.spacing(1),
    color: "#8601af",
  },
}));

const Footer = () => {
  const classes = useStyles();

  return (
    <AppBar position="static" className={classes.footer} elevation={0}>
      <Container>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={4}>
            <img
              src="/assets/images/mbali_logo-removebg-preview.png"
              alt="Logo"
              className={classes.logo}
            />
            <Typography variant="body2">
              NgeMbalenhle Tutoring Services is dedicated to providing quality
              education for all students. We believe in empowering students to
              achieve their dreams.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" className={classes.sectionTitle}>
              Contact
            </Typography>
            <div className={classes.contactItem}>
              <MailOutlineIcon className={classes.contactIcon} />
              <Typography variant="body2">
                <Link
                  href="mailto:ngembalenhle@gmail.com"
                  className={classes.link}
                >
                  ngembalenhle@gmail.com
                </Link>
              </Typography>
            </div>
            <div className={classes.contactItem}>
              <PhoneIcon className={classes.contactIcon} />
              <Typography variant="body2">Phone: 0677505304</Typography>
            </div>
            <div className={classes.contactItem}>
              <LocationOnIcon className={classes.contactIcon} />
              <Typography variant="body2">
                Address: 23A 10th avenue, Rivonia Sandton
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" className={classes.sectionTitle}>
              Follow Us
            </Typography>
            <IconButton className={classes.socialMediaIcon}>
              <FacebookIcon />
            </IconButton>
            <IconButton className={classes.socialMediaIcon}>
              <TwitterIcon />
            </IconButton>
            <IconButton className={classes.socialMediaIcon}>
              <InstagramIcon />
            </IconButton>
            <IconButton className={classes.socialMediaIcon}>
              <LinkedInIcon />
            </IconButton>
          </Grid>
        </Grid>
        <Toolbar>
          <Typography variant="body2" className={classes.copyright}>
            ©2023 by NgeMbalenhle Tutoring Services. All rights reserved.
          </Typography>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Footer;
